import type { ReactNode } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import './content-brief-blocks.css'

import { ScrollArea } from '@/components/ui/scroll-area'
import { ContentBriefBlock } from './content-brief-block.atom'
import type { ParsedBlock } from './content-brief-parser.helper'

export interface ContentBriefBlockListProps {
  blockList: ParsedBlock[]
  commentMap: Record<number, string>
  onCommentChange: (blockIndex: number, comment: string | undefined) => void
  isReadOnly?: boolean
}

const remarkPluginList = [remarkGfm]

export const ContentBriefBlockList: React.FC<ContentBriefBlockListProps> = ({
  blockList,
  commentMap,
  onCommentChange,
  isReadOnly = false,
}): ReactNode => (
  <ScrollArea className="content-brief-scroll h-full">
    <div className="content-brief-blocks saaga-wysiwyg flex w-full flex-col gap-0 overflow-x-auto pb-24 pt-8 pl-8 pr-9 [word-break:break-word]">
      {blockList.map((block) =>
        isReadOnly ? (
          <div key={block.index} className="content-brief-block-readonly px-2 py-1">
            <Markdown remarkPlugins={remarkPluginList}>{block.content}</Markdown>
          </div>
        ) : (
          <ContentBriefBlock
            key={block.index}
            blockIndex={block.index}
            comment={commentMap[block.index]}
            onCommentChange={(comment) => onCommentChange(block.index, comment)}
          >
            <Markdown remarkPlugins={remarkPluginList}>{block.content}</Markdown>
          </ContentBriefBlock>
        )
      )}
    </div>
  </ScrollArea>
)
